import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { LoadingSpinner } from '../../../components/indicator';
import { ECheckoutStatus } from '../../../../../common/interfaces/checkout';
import { Button, EButtonType } from '../../../components/action/Button';

// Styles
const s = require('./PortalCheckout.css');

// Props
interface IPortalCheckoutOrderedProps {
    onApprove: () => void;
    status: ECheckoutStatus;
    orderRequestId: number | null;
}

// Component
@observer
export class PortalCheckoutOrdered extends React.Component<IPortalCheckoutOrderedProps, {}> {
    static get defaultProps(): IPortalCheckoutOrderedProps {
        return {
            onApprove: () => undefined,
            status: ECheckoutStatus.CheckoutProcessing,
            orderRequestId: null
        };
    }

    constructor(props) {
        super(props);

        setTimeout(() => {
            this.showSpinner = true;
        }, 256);
    }

    @observable private showSpinner: boolean = false;

    public render() {
        return (
            <div className={s.checkout}>
                {this.props.status === ECheckoutStatus.CheckoutError && (
                    <div className={s.retryContainer}>
                        <h1>We could not submit the order at this time</h1>

                        <Button inBox={true} type={EButtonType.Action} onClick={this.handleRetry}>
                            Try again
                        </Button>
                    </div>
                )}

                {this.props.status === ECheckoutStatus.CheckoutProcessing && (
                    <div>
                        <LoadingSpinner active={this.showSpinner} size={64} />
                        <p>Processing order...</p>
                    </div>
                )}

                {this.props.status === ECheckoutStatus.CheckoutSuccess && (
                    <div>
                        <h1>Your order has been placed</h1>
                        {this.props.orderRequestId !== null && (
                            <p>
                                <span>Order request #</span>
                                <strong>{this.props.orderRequestId}</strong>
                            </p>
                        )}
                    </div>
                )}
            </div>
        );
    }

    private handleRetry = () => {
        this.props.onApprove();
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalCheckout/PortalCheckoutOrdered.tsx